import * as ActionTypes from '../../actions/allActions'

const forgotPasswordInit = { email: "" }
const forgotPassword = (state = forgotPasswordInit, action) => {
	switch (action.type) {
		case ActionTypes.FORGOTPASSWORD_DATACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.LOGOUT:
			return forgotPasswordInit
		default:
			return state
	}
}

export default forgotPassword


// WEBPACK FOOTER //
// ./src/reducers/data/forgotPassword.js